import React from 'react';
import styles from './styles.css';

export default function Caret(props) {
  let width = props.width ? props.width : '10px';
  let height = props.height ? props.height : '6px';

  let fillColor;
  switch (props.type) {
    case 'blue':
      fillColor = '#005eb8';
      break;
    case 'white':
      fillColor = '#ffffff';
      break;
    case 'grey':
      fillColor = '#72808a';
      break;
    case 'filled':
      fillColor = '#000000';
      break;
    case 'unfill':
      fillColor = '#d0d4d8';
      break;
    default:
      fillColor = '#005eb8';
  }

  let isDown;
  let viewBoxVal;
  switch (props.direction) {
    case 'down':
      isDown = 'rotate(180) translate(-27, -24)';
      viewBoxVal = '0 0 10 6';
      break;
    case 'up':
      isDown = 'rotate(0) translate(-18, -20)';
      viewBoxVal = '0 0 10 6';
      break;
    case 'left':
      isDown = 'rotate(270) translate(-5, 10)';
      viewBoxVal = '-2 0 10 6';
      break;
    case 'right':
      isDown = 'rotate(90) translate(-20, -29)';
      viewBoxVal = '2 0 10 6';
      break;
    default:
      isDown = 'rotate(0) translate(-18, -20)';
      viewBoxVal = '0 0 10 6';
  }

  return (
    <svg
      className={styles.svg}
      version="1.1"
      overflow="visible"
      preserveAspectRatio="none"
      viewBox={viewBoxVal}
      width={width}
      height={height}
    >
      <g
        id="Components"
        transform={isDown}
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g id="Dropdown-No-Label-/-Medium-/-Focussed" fill={fillColor}>
          <g id="Input-Box">
            <g id="Dropdown-Button">
              <polygon id="Triangle" points="22 19 27 25 17 25"></polygon>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}
